import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Hand } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const RHYTHM_EVENT = "jt-rhythm-board";

export const RhythmLeaderboard = ({ testId = "rhythm-leaderboard", showLink = false }) => {
  const { user } = useAuth();
  const [board, setBoard] = useState(null);
  useEffect(() => {
    const load = () => api.get("/rhythm-clap/leaderboard").then(({ data }) => setBoard(data)).catch(() => setBoard({ entries: [] }));
    const onBoard = (e) => setBoard(e.detail);
    load();
    window.addEventListener(RHYTHM_EVENT, onBoard);
    return () => window.removeEventListener(RHYTHM_EVENT, onBoard);
  }, [user]);

  return (
    <section className="mt-8 rounded-3xl border border-border bg-card p-6" data-testid={testId}>
      <div className="flex flex-wrap items-center gap-2">
        <Hand size={18} className="text-primary" />
        <h2 className="font-serif text-xl">Rhythm Clap · this week's challenge top 10</h2>
        {board?.week && <span className="ml-auto font-mono text-[11px] uppercase tracking-widest text-muted-foreground">{board.week}</span>}
      </div>
      <p className="mt-1 text-sm text-muted-foreground">
        Everyone claps the same rhythm each week (Level 3, 80 bpm) — ranked by best score. A new challenge starts every Monday. Free practice isn't ranked. {user ? "Your best score is saved automatically." : "Log in and your best score is saved automatically."}
        {showLink && <> <Link to="/rhythm-clap" className="text-primary hover:underline" data-testid={`${testId}-play-link`}>Play Rhythm Clap →</Link></>}
      </p>
      <ol className="mt-4 divide-y divide-border" data-testid={`${testId}-list`}>
        {!board?.entries?.length ? <li className="py-3 text-sm text-muted-foreground" data-testid={`${testId}-empty`}>No scores yet this week — be the first!</li> : board.entries.map((e) => (
          <li key={e.rank} className={`flex items-center gap-3 py-2.5 text-sm ${e.is_me ? "text-primary" : ""}`} data-testid={`${testId}-row-${e.rank}`}>
            <span className="w-6 font-mono text-muted-foreground">{e.rank}</span>
            <span className="font-medium">{e.name}{e.is_me ? " (you)" : ""}</span>
            <span className="ml-auto text-muted-foreground">{e.score}% · level {e.level} · {e.bpm} bpm</span>
          </li>
        ))}
      </ol>
      {board?.my_rank > 10 && <p className="mt-2 text-xs text-primary" data-testid={`${testId}-my-rank`}>You're #{board.my_rank} this week with {board.my_score}%.</p>}
    </section>
  );
};
